import { render, staticRenderFns } from "./SwitchButton.vue?vue&type=template&id=2d740c72&scoped=true&"
import script from "./SwitchButton.vue?vue&type=script&lang=js&"
export * from "./SwitchButton.vue?vue&type=script&lang=js&"
import style0 from "./SwitchButton.vue?vue&type=style&index=0&id=2d740c72&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d740c72",
  null
  
)

export default component.exports